import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/** !!!: import all icons .. change this with Tree shaking alternative when deploying (commented below) */
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// import {
//   faSpinner,
//   faHome,
//   faFolderOpen,
//   faUsers,
//   faCogs,
//   faList,
//   faThList,
//   faBuilding,
//   faSitemap,
//   faGavel,
//   faUserCheck,
//   faPlay,
//   faBars,
//   faPlus,
//   faPlusCircle,
//   faPen,
//   faTrashAlt,
//   faInfoCircle,
//   faTimesCircle,
//   faTimes,
//   faSave,
//   faArrowRight,
//   faCopy,
//   faVoteYea,
//   faUpload,
//   faDownload,
//   faChevronUp,
//   faSort,
//   faSync,
// } from "@fortawesome/free-solid-svg-icons";

// library.add(
//   faSpinner,
//   faHome,
//   faFolderOpen,
//   faUsers,
//   faCogs,
//   faList,
//   faThList,
//   faBuilding,
//   faSitemap,
//   faGavel,
//   faUserCheck,
//   faPlay,
//   faBars,
//   faPlus,
//   faPlusCircle,
//   faPen,
//   faTrashAlt,
//   faInfoCircle,
//   faTimesCircle,
//   faTimes,
//   faSave,
//   faArrowRight,
//   faCopy,
//   faVoteYea,
//   faUpload,
//   faDownload,
//   faChevronUp,
//   faSort,
//   faSync
// );
